import { render, staticRenderFns } from "./UnpaidInvoiceBanner.vue?vue&type=template&id=3dc1ce72&scoped=true"
import script from "./UnpaidInvoiceBanner.vue?vue&type=script&lang=js"
export * from "./UnpaidInvoiceBanner.vue?vue&type=script&lang=js"
import style0 from "./UnpaidInvoiceBanner.vue?vue&type=style&index=0&id=3dc1ce72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc1ce72",
  null
  
)

export default component.exports